module.exports = __webpack_public_path__ + "static/media/Features 5.666f4d80.svg";